import { getIngestExclusionProducts, updateIngestExclusionProducts, getExclusionLicensePlates, updateLicensePlateExclusion } from "../../settingsService";
import { BaseSettingsService } from "./BaseSettingsService";

// Global settings strategy
export class GlobalSettingsService extends BaseSettingsService {
    async getSettings() {
        try {
            //* Fetch all global settings concurrently:
            const [productsResponse, licensePlatesResponse] = await Promise.all([
                getIngestExclusionProducts(),
                getExclusionLicensePlates(),
            ]);
            return {
                INGEST_PRODUCT_EXCLUSION: productsResponse,
                LICENSE_PLATE_EXCLUSION: licensePlatesResponse,
            };
        } catch (error) {
            throw error;
        }
    }

    async updateSetting({settingSelected, value}) {
        try {
            const key = settingSelected.key;

            if (key === "INGEST_PRODUCT_EXCLUSION") {
                const excludedProducts = value.map((product) => ({
                    code_type: product.code_type,
                    code: product.code,
                    isDeleted: product.isDeleted,
                }));
                const response = await updateIngestExclusionProducts(excludedProducts);
                return {settingValue: value, response };
            }
            else if (key === "LICENSE_PLATE_EXCLUSION") {
                const excludedLicensePlates = value.map((licensePlate) => ({
                    licensePlate: licensePlate.license_plate,
                    licenseState: licensePlate.state,
                    isDeleted: licensePlate.isDeleted,
                }))                
                const response = await updateLicensePlateExclusion(excludedLicensePlates);
                return {settingValue: value, response };
            }
        }
        catch(error){
            throw error;
        }
    }

    mapResponseToLocalValue({settingsData, settingSelected}, settingValue ){
        return settingsData.map((category) => ({
            ...category,
            data: category.data.map((setting) =>
                {
                    if (setting.label === settingSelected.label) {
                        let mappedValue;
                        
                        if (settingSelected.key === "INGEST_PRODUCT_EXCLUSION") {
                            mappedValue = this.#mapIngestProducExclusionDataToLocalValue(setting.value, settingValue);
                        } else if (settingSelected.key === "LICENSE_PLATE_EXCLUSION") {
                            mappedValue = this.#mapLicensePlateExclusionDataToLocalValue(setting.value, settingValue);
                        }
                                    
                        return {
                            ...setting,
                            value: mappedValue,
                        };
                    } else {
                        return setting;
                    }
                })
            }));        
    }

    #mapIngestProducExclusionDataToLocalValue(settingsData, settingValue) {
        let newSettingsData = { ...settingsData };

        for (const setting of settingValue) {
            const { propertyKey, code, isDeleted, item } = setting;

            const currentProductSetting = Array.isArray(newSettingsData[propertyKey])
            ? [...newSettingsData[propertyKey]]
            : [];

            if (isDeleted) {
                newSettingsData[propertyKey] = currentProductSetting.filter((existing) => existing.code !== code);
            } else {
                if (!currentProductSetting.includes(item)) {
                    currentProductSetting.push(item);
                }
                newSettingsData[propertyKey] = currentProductSetting;
            }
        }

        return newSettingsData;
    }

    #mapLicensePlateExclusionDataToLocalValue(settingsData, settingValue) {
        let newSettingsData = Array.isArray(settingsData) ? [...settingsData] : [];
    
        for (const setting of settingValue) {
            const { license_plate, state, isDeleted } = setting;
    
            if (isDeleted) {
                newSettingsData = newSettingsData.filter(
                    (existing) => !(existing.license_plate === license_plate && existing.state === state)
                );
            } else {
                const exists = newSettingsData.some(
                    (existing) => existing.license_plate === license_plate && existing.state === state
                );
                if (!exists) {
                    newSettingsData.push({ license_plate, state });
                }
            }
        }
    
        return newSettingsData;
    }
}
